import { mergeDeep } from '../env.base';
import BASE_CONFIG from '../env.base';

const brandOverrides = {
  BRAND: 'royal',
  TEALIUM: {
    BRAND_CODE: 'postbooking-apps',
  },
  TELEMETRY: {
    APP_ID: BASE_CONFIG.TELEMETRY.APP_ID
  },
  ADVERTISEMENT: {
    BOARDING_PASS_PAGEID: '2209'
  },
  LOADER: 'assets/images/royal/loader.json'
};

export default mergeDeep(BASE_CONFIG, brandOverrides);
